// Native Play scoring follows Moving Answers: only the first independent answer
// is correct for reporting. Segment navigation cannot erase a failed attempt.
export function createRunLedger(problems) {
  const entries = problems.map(problem => ({
    assessed: problem.type !== 'explanation', attempts: 0, failures: 0,
    revealed: false, skipped: false, resolved: false, firstTryCorrect: false,
  }));
  let completedOnExit = false;
  const ledger = {
    entries,
    answer(index, correct) {
      const entry = entries[index];
      if (!entry?.assessed || entry.resolved) return false;
      entry.attempts += 1;
      if (!correct) entry.failures += 1;
      if (correct) {
        entry.resolved = true;
        entry.firstTryCorrect = entry.attempts === 1 && !entry.revealed && !entry.skipped;
      }
      return true;
    },
    reveal(index) {
      const entry = entries[index];
      if (!entry?.assessed || entry.resolved) return false;
      entry.revealed = true;
      entry.resolved = true;
      entry.firstTryCorrect = false;
      return true;
    },
    leave(index) {
      const entry = entries[index];
      if (!entry) return;
      if (!entry.assessed) entry.resolved = true;
      else if (!entry.resolved) entry.skipped = true;
    },
    // A trailing Explanation is an interactive, unscored workspace. Its
    // narration ending must not finish the activity; the native Go Back action
    // can publish results once the learner chooses to leave it.
    canCompleteOnExit(index) {
      if (completedOnExit || !Number.isInteger(index) || !entries[index] || entries[index].assessed) return false;
      const lastAssessed = entries.reduce((last, entry, position) => entry.assessed ? position : last, -1);
      if (lastAssessed < 0 || index <= lastAssessed || entries.some(entry => entry.assessed && !entry.resolved)) return false;
      return entries.slice(lastAssessed + 1).every((entry, position) => entry.resolved || lastAssessed + 1 + position === index);
    },
    completeOnExit(index) {
      if (!ledger.canCompleteOnExit(index)) return null;
      completedOnExit = true;
      ledger.leave(index);
      return ledger.results();
    },
    results() {
      const questions = entries.filter(entry => entry.assessed);
      const answers = questions.map(entry => Number(entry.firstTryCorrect));
      const correct = answers.reduce((sum, value) => sum + value, 0);
      return {
        withScore: questions.length > 0,
        isCongratulations: questions.length === 0,
        data: {
          allProblemsCount: questions.length,
          problemsAnsweredCorrectly: correct,
          problemsAnsweredIncorrectly: questions.length - correct,
          answersByQuestion: answers,
          rawAssessment: { answersByQuestion: answers },
        },
      };
    },
  };
  return ledger;
}
